import type Validator from '../../models/Validator';

const FORMAT_ERROR = 'Phone number must be in the format (XXX) XXX-XXXX';
const AREA_CODE_ERROR = 'Area code cannot start with 0 or 1';
const MIDDLE_DIGITS_ERROR = 'The 4th digit of a phone number cannot be 0 or 1';

const PhoneValidator: Validator = class {
  static isValid(value) {
    if (!value) {
      return false;
    }

    // Extract just the digits - accept any format as long as we have 10 valid digits
    const digits = value.replace(/\D/g, '');

    if (digits.length !== 10) {
      return false;
    }

    // Area code cannot start with 0 or 1
    if (digits[0] === '0' || digits[0] === '1') {
      return false;
    }

    // Exchange code cannot start with 0 or 1
    if (digits[3] === '0' || digits[3] === '1') {
      return false;
    }

    return true;
  }

  static getError(value?: string) {
    if (!value) {
      return FORMAT_ERROR;
    }

    const digits = value.replace(/\D/g, '');

    // Check digit-specific errors first (more helpful to user)
    if (digits.length >= 1 && (digits[0] === '0' || digits[0] === '1')) {
      return AREA_CODE_ERROR;
    }

    if (digits.length >= 4 && (digits[3] === '0' || digits[3] === '1')) {
      return MIDDLE_DIGITS_ERROR;
    }

    // Check length
    if (digits.length !== 10) {
      return FORMAT_ERROR;
    }

    return null;
  }
};

export default PhoneValidator;
